import { Component} from '@angular/core';

@Component({
  selector: 'app-evaluation',
  templateUrl: './evaluation.component.html',
  styleUrls: ['./evaluation.component.scss'],
  providers: []
})
export class EvaluationComponent  {
  constructor() { }
}
